import { useLocation } from 'react-router';

/**
 * Returns query parameters of current URL
 * Eg:
 * current location is askokey.com/login?redirect=/dashboard
 *
 * Here, everything after ? is the query parameter
 *
 * NOTE: URLSearchParams does not work in IE but MSFT has discontinued IE as of this writing so it's not a concern
 * @returns String
 */
const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

export default useQuery;
